module.exports = __webpack_public_path__ + "img/pic-lc.8868d008.png";